import { useEffect } from 'react';

function useGlobalTourCheck(onTour: () => void,path:string) {
  useEffect(() => {
    const visitedKey = `visited:${path}`;
    if (!localStorage.getItem(visitedKey)) {
      onTour();
      localStorage.setItem(visitedKey, '1');
    }
  }, [path, onTour]);
}

export default useGlobalTourCheck;
